(function ($) {
	$(document).ready(function () {
		/* change header bg color on scroll */
		const siteNav = $("#siteNav");

		$(window).scroll(function () {
			// let scroll = $(window).scrollTop();

			// if not at the top of the screen add class
			if (window.scrollY > 0) {
				siteNav.addClass("scrolled");
			} else {
				// if click on anything else, remove active class.
				siteNav.removeClass("scrolled");
			}
		});
	});
})(jQuery);
